import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'idme:profile-section:title': {
    id: 'idme:profile-section:title',
    defaultMessage: 'Community verification',
    description: 'Title for the ID.me profile section in the user profile.',
  },
  'idme:profile-section:description': {
    id: 'idme:profile-section:description',
    defaultMessage: 'Verify your community status for exclusive COCO Rewards deals & offers!',
    description: 'Description for the ID.me profile section in the user profile.',
  },
  'idme:verified-status-message': {
    id: 'idme:verified-status-message',
    defaultMessage: 'Verified as: {statuses}',
    description: 'Message for ID.me verified status which includes list of verified statuses.',
  },
});
